import { LatLngExpression, Map as LeafletMap } from 'leaflet';
import { MdMyLocation } from 'react-icons/md';
import { FaPlus, FaMinus } from 'react-icons/fa6';
import { IconButton } from '@ds';

type MapControlsProps = {
  map: LeafletMap;
  defaultCenter: LatLngExpression;
};

export const MapControls = ({ defaultCenter, map }: MapControlsProps) => {
  return (
    <div className="absolute z-402 right-4 bottom-4 flex flex-col gap-2">
      <IconButton
        size="sm"
        type="button"
        radius="sm"
        className="text-base-5 bg-white data-[hover=true]:bg-base-80"
        startContent={<MdMyLocation size={24} />}
        onPress={() => map.flyTo(defaultCenter)}
      />
      <IconButton
        size="sm"
        type="button"
        radius="sm"
        className="text-base-5 bg-white data-[hover=true]:bg-base-80"
        startContent={<FaPlus size={24} />}
        onPress={() => map.zoomIn()}
      />
      <IconButton
        size="sm"
        type="button"
        radius="sm"
        className="text-base-5 bg-white data-[hover=true]:bg-base-80"
        startContent={<FaMinus size={24} />}
        onPress={() => map.zoomOut()}
      />
    </div>
  );
};
